module.exports = __webpack_public_path__ + "static/dom-ce93435bc4d4b28a01379504524bdcc4.jpg";